import { GlButton } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
// NOTE! For the first iteration, we are simply copying the implementation of Assignees
// It will soon be overhauled in Issue https://gitlab.com/gitlab-org/gitlab/-/issues/233736
import { TYPE_ISSUE } from '~/issues/constants';
import UncollapsedReviewerList from './uncollapsed_reviewer_list.vue?vue3';
export default {
    name: 'ReviewersList',
    components: {
        GlButton,
        UncollapsedReviewerList
    },
    props: {
        users: {
            type: Array,
            required: true
        },
        editable: {
            type: Boolean,
            required: true
        },
        canRerequest: {
            type: Boolean,
            required: false,
            default: false
        },
        issuableType: {
            type: String,
            required: false,
            default: TYPE_ISSUE
        }
    },
    emits: [
        'assign-self',
        'remove-reviewer',
        'request-review'
    ],
    computed: {
        hasNoUsers () {
            return !this.users.length;
        },
        sortedReviewers () {
            const canMergeUsers = this.users.filter((user)=>user.mergeRequestInteraction?.canMerge);
            const canNotMergeUsers = this.users.filter((user)=>!user.mergeRequestInteraction?.canMerge);
            return [
                ...canMergeUsers,
                ...canNotMergeUsers
            ];
        }
    },
    methods: {
        assignSelf () {
            this.$emit('assign-self');
        },
        requestReview (data) {
            this.$emit('request-review', data);
        },
        removeReviewer (data) {
            this.$emit('remove-reviewer', data);
        }
    }
};
